"use client"

import IconChevronDown from "@/app/(site)/_components/Atoms/Icons/IconChevronDown"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { SHIPPING_COUNTRY_CODES } from "@/data/shipping-country-code"
import { useEffect, useState } from "react"
import ButtonText from "../../../Molecules/ButtonText"

interface CountryPickerButtonProps {
    mobile?: boolean
    fallbackCentraSessionData: {
        countryCode?: string
        langCode?: string
    }
    locale: string
}

export default function CountryPickerButton({
    mobile,
    fallbackCentraSessionData,
    locale
}: CountryPickerButtonProps) {
    const setShowCountryPicker = useEcommerceStore(state => state.setShowCountryPicker)
    const centraSession = useEcommerceStore(state => state.centraSession)
    const [createdLocale, setCreatedLocale] = useState<string | null>(
        fallbackCentraSessionData.countryCode + "/" + fallbackCentraSessionData.langCode
    )

    const handleOnClick = () => setShowCountryPicker(true)

    useEffect(() => {
        if (locale !== SHIPPING_COUNTRY_CODES.France && locale.length === 2) {
            setCreatedLocale(
                `${centraSession?.metadata?.country?.code.toUpperCase()}/${centraSession?.metadata?.language.toUpperCase()}`
            )
        }
    }, [centraSession?.metadata?.country?.code, centraSession?.metadata?.language])

    return (
        <ButtonText
            asChild
            onClick={handleOnClick}
            icon={<IconChevronDown className="-mt-1 h-16 w-16 md:flex" />}
            iconPosition="right"
            size="small"
            className={`flex gap-3 px-20 py-18 ${mobile ? "flex pl-8 !text-12 md:hidden" : "hidden md:flex"}`}
        >
            <span>{createdLocale}</span>
        </ButtonText>
    )
}
